import { call, put, takeEvery } from 'redux-saga/effects';
import { repositories } from 'api';
import * as types from './types';
import * as actions from './actions';

export { actions };

const checkout = new repositories.Checkout();

type Action = {
    type: string;
    payload: string;
};

function* fetchCheckoutData(action: Action) {
    try {
        const { data } = yield call([checkout, 'get'], action.payload);

        yield put(actions.fetchCheckoutData.success(data));
    } catch (error) {
        yield put(actions.fetchCheckoutData.failure(error.response.data));
    }
}

function* checkoutSaga() {
    yield takeEvery<any>(types.FETCH_CHECKOUT_DATA_REQUEST, fetchCheckoutData);
}

export default checkoutSaga;
